import angular from 'angular';

import AccountsListComponent from './list.component';
import CreateSubAccountComponent from './create.component';
import SubAccountViewComponent from './view.component';

let subAccountsModule = angular
  .module('admin.sub-accounts', [])
  .component('subAccountView', SubAccountViewComponent)
  .component('createSubAccount', CreateSubAccountComponent)
  .component('accountsList', AccountsListComponent);

export default subAccountsModule.name;
